<template>
	<v-card class='elevation-0 agenda-page agenda-page-container pt-7'>
		<div class='d-flex'>
			<v-skeleton-loader
				v-if='isLoading'
				v-bind='attrs'
				width='600'
				type='list-item, list-item-three-line, card-heading'
			>
			</v-skeleton-loader>

			<div v-else style='width: 100%'>
				<div class='mb-4'>
					<router-link
						:to="{ name: 'event-by-id', params: { id: this.$route.params.id } }"
						class='d-flex text-decoration-none'
					>
						<v-icon small class='mr-1'> mdi-arrow-left-circle</v-icon>
						<div class='event-card__link'>Back</div>
					</router-link>
				</div>

				<div class='agenda-page__title'>Agenda</div>

				<div v-for='{ date, data } in groupedByMonthAndDay' :key='date'>
					<div class='agenda-page__title'>{{ date }}</div>

					<div v-for='(agenda, index) in data' :key='index'>
						<router-link
							v-if='agenda.is_extended'
							:to="{ name: 'event-session-by-id', params: {
								eventId: agenda.events_id,
								sessionId: agenda.events_agenda_id
							} }"
							class='d-flex text-decoration-none'
							style='width: 100%;'
						>
							<AgendaCard :agenda-event='agenda' />
						</router-link>
						<AgendaCard
							v-else
							:agenda-event='agenda'
						/>
					</div>
				</div>

				<div
					class='d-flex my-9 justify-center home-page__pagination'
					v-if='!isLoading && agendaEvent.length > 0'
				>
					<v-pagination
						color='#F2F2F2'
						:total-visible='10'
						circle
						v-model='filters.page'
						@input='(e) => onPageChange(e)'
						:length='+this.pageCountAgendas'
					></v-pagination>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AgendaCard from '@/components/Event/AgendaCard'

export default {
	name: 'AgendasPage',
	components: {
		AgendaCard,
	},
	methods: {
		...mapActions('event', ['getAgendaEvent']),

		onPageChange(page) {
			const params = {
				page: page,
			}
			const queryString = this.formatFilters(params)
			this.getAgendas(queryString)
		},

		formatFilters(filters) {
			const { page } = filters

			return `&event_id=${this.$route.params.id}&page=${page}`
		},

		async getAgendas(additionalQueryParams = '') {
			await this.getAgendaEvent(additionalQueryParams)
		},
	},

	created() {
		if (this.$route.params.id !== undefined) {
			this.getAgendaEvent(`&event_id=${this.$route.params.id}`)
		}
	},

	computed: {
		...mapGetters('event', ['isLoading', 'pageCountAgendas', 'agendaEvent']),

		groupedByMonthAndDay() {
			return Object.values(
				this.agendaEvent.reduce((prev, current) => {
					const fromDate = new Date(current.events_agenda_from * 1000)

					const month = fromDate.toLocaleString('en-US', { month: 'long' })
					const year = fromDate.getFullYear()
					const day = fromDate.getDate()
					const key = `${month} ${day}, ${year}`

					if (!prev[key]) {
						prev[key] = {
							date: key,
							data: [],
						}
					}

					prev[key].data.push(current)

					return prev
				}, {}),
			).map((item) => {
				const { data } = item

				return {
					...item, data: data.sort((a, b) => {
						const { events_agenda_from: aEventsFrom } = a
						const { events_agenda_from: bEventsFrom } = b

						return aEventsFrom - bEventsFrom
					}),
				}
			})
		},
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
		}
	},
}
</script>

<style lang='scss'>
.agenda-page {
	background: #f1f1f1 !important;

	&__title {
		color: rgb(74, 74, 74);
		font-size: 18px;
		font-family: Montserrat;
		font-weight: bold;
		margin-bottom: 10px;
	}
}

@media screen and (min-width: 1200px) {
	.agenda-page-container {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.agenda-page-container {
		max-width: 600px;
	}
}
</style>
